import React from "react";
import { HelpCircle } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "./ui/tooltip";

export const Help = ({ text, testid }) => (
  <Tooltip delayDuration={100}>
    <TooltipTrigger asChild>
      <button
        type="button"
        data-testid={testid}
        aria-label="Help"
        className="inline-flex items-center justify-center rounded-full text-muted-foreground/70 transition-colors hover:text-primary"
      >
        <HelpCircle className="h-4 w-4" />
      </button>
    </TooltipTrigger>
    <TooltipContent className="max-w-[260px] text-xs leading-relaxed">{text}</TooltipContent>
  </Tooltip>
);
